import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6da1f440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "rel"
}
const _hoisted_4 = { class: "tip abs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/bg_1.png",
  alt: "",
  class: "bg"
}, null, -1))
const _hoisted_6 = ["innerHTML"]

import { t } from '@/plugins/i18n'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useRtfix } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const [getValue, setValue] = useUserConfig(ENUM_CONFIG_CODE.API_ASSOCIATED)
const isShow = ref(false)
onMounted(async () => {
  isShow.value = await getValue() !== '1'
})
const close = async () => {
  setValue('1')
  isShow.value = !await getValue()
}
const backUp = () => {
  if (history.state?.position === 1) {
    router.push(useRtfix('AssociatedProductlib'))
    return
  }
  history.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SvgIcon, {
      name: "返回-return",
      class: "return-icon",
      onClick: backUp
    }),
    _createElementVNode("span", {
      class: "return-text",
      onClick: backUp
    }, _toDisplayString(_unref(t)('返回')), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('创建关联商品')), 1),
    (isShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("img", {
              src: "https://static-s.theckb.com/BusinessMarket/Client/associated/close.png",
              alt: "",
              class: "close",
              onClick: close
            }),
            _createElementVNode("div", {
              class: "tip-text",
              innerHTML: _unref(t)('关联商品可以支持(1对多)的绑定啦！').replace(/\((.*)\)/, `<span>$1</span>`)
            }, null, 8, _hoisted_6)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})